import axios from 'axios';
import { apiUrl } from '../Config';


const getAuthToken = () => {
    return (
        localStorage.getItem('token')
    );
}

export const getActiveIndustries = async () => {
    try {
        const response = await axios.get(`${apiUrl}/industry/active`, {
            headers: { 'Authorization': `Bearer ${getAuthToken()}` }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to get industry:', error);
        throw error;
    }
}   

